<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/pest-step1')"></span>
    </div>
    <div class="title">请选择除虫服务<br>（多选）</div>
    <br>
    <div class="main">

      <div class="weui-cells weui-cells_checkbox">
          <label class="weui-cell weui-check__label" for="k11">
              <div class="weui-cell__hd">
                  <input type="checkbox" class="weui-check" name="checkbox" id="k11" v-model="order.data.pest_standard">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                <div class="btn-long no-margin-top" :class="{ active: order.data.pest_standard}">
                  <div class="col1">
                    <img class="promo-image" src='../../assets/img/pest/chuchong.svg'>
                  </div>
                  <div class="col2">
                    <div class="col2-row1">一般害虫</div>
                    <div class="col2-row2">大蟑螂、蚂蚁、蜘蛛、银鱼、蟋蟀、马蜂、其他小爬虫等</div>
                  </div>
                </div>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="k12">
              <div class="weui-cell__hd">
                  <input type="checkbox" name="checkbox" class="weui-check" id="k12"  v-model="order.data.pest_german">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                <div class="btn-long" :class="{ active: order.data.pest_german}">
                  <div class="col1">
                    <img class="promo-image" src='../../assets/img/pest/xiaolian.svg'>
                  </div>
                  <div class="col2">
                    <div class="col2-row1">小蟑螂（德国小蠊）</div>
                    <div class="col2-row2">厨房和卫生间中常见的小蟑螂，繁殖力强，需要特别治理。包含二次检查</div>
                  </div>
                </div>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="k13">
              <div class="weui-cell__hd">
                  <input type="checkbox" name="checkbox" class="weui-check" id="k13"  v-model="order.data.pest_mouse">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                <div class="btn-long" :class="{ active: order.data.pest_mouse}">
                  <div class="col1">
                    <img class="promo-image" src='../../assets/img/pest/laoshu.svg'>
                  </div>
                  <div class="col2">
                    <div class="col2-row1">老鼠</div>
                    <div class="col2-row2">专业除鼠服务，包含除鼠盒子安装和二次检查</div>
                  </div>
                </div>
              </div>
          </label>


      </div>
      <div v-show="localErrorShow">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><br>{{localError[0]}}<br><br></div>
              <div class="weui-dialog__ft">
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
              </div>
          </div>
      </div>
    </div>
    <div class="btn-box-fix">
<!--       <div class="slogan">想了解更多害虫信息，请点击
        <span class="color-orange">
          <span @click="$router.push('/service/clean-price?service=dasaochu');">大扫除清洁报价单</span>
        </span>
      </div> -->
      <div class="btn-container">
        <div class="btn" @click="nextStep()" :class="{ active: allFilled()}" >下一步</div>
      </div>
    </div>
    <img :src="pixelURL('cangchu','step2')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step3',
  data () {
    return {
      order:{},
      localError:[],
      localErrorShow:false,
    }
  },
  methods: {
    allFilled(){
       if(this.order.data.pest_standard || this.order.data.pest_german || this.order.data.pest_mouse ){
            return true;
        }
    },
    checkSubmit(){
        this.localError = [];
        if (!this.allFilled()) {
            this.localError.push("请至少选择一项除虫服务");
        }
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    nextStep: function() {
        if(!this.checkSubmit()){
            return false;
        }
        else{
            if(this.order.data.pest_standard){
              if(localStorage.isEditing){
                this.orderSkipEditAndUpdateAll('/pest-step3')
              }
              else{
                this.orderUpdateAll('/pest-step3');
              }
            }
            else{
              this.orderUpdateAll('/pest-step4');
            }
        }
    },
  },
  created: function () {
    //如果LS存在老的下单信息
    if (localStorage.savedPest){
      //如果LS不存在order字段，则将老下单信息覆盖LS的order字段
      if(!localStorage.order){
        localStorage.order = localStorage.savedPest;
      }//如果LS存在order字段，判断其是否属于当前服务类型：如果否，则将老下单信息覆盖LS的order字段
      if(localStorage.order){
        let localParsed = JSON.parse(localStorage.order);
        if(localParsed.service != "pest"){
          localStorage.order = localStorage.savedPest;
        }
      }
    }
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "pest"){
        this.order = localParsed;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell:before{
  display:none;
}

.container /deep/ .weui-cells:after, .container /deep/ .weui-cells:before{
  display:none;
}

.btn-long{
  width: 100%;
  min-height: 80px;
  cursor: pointer;
  display: flex;
  justify-content:space-around;
  align-items: center;
  border-radius: 5px;
  font-size: 1.1em;
  box-sizing:border-box;
  text-align:left;
  font-weight:bold;
  border:2px solid #ddd;
  border-radius:10px;
  padding:14px 10px;
  &.active{
    border:2px solid $color-orange;
  }
}

.btn-intro{
  font-size:0.7em;
  font-weight:normal;
}


.no-margin-top{
  margin-top:0;
}

.promo-image{
  width:80%;
  margin:6px auto;
  display:block;
  
}

.col1{
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}

.col1-row1{
  color:#555;
  line-height:1;
  font-size:1.1em;
}
.col1-row2{
  border:1px solid #ff7444;
  border-radius:3px;
  font-size:0.7em;
  font-weight:200;
  color:#000;
  padding:0px 5px;
  display:inline-block;
}

.col2{
    -webkit-box-flex: 7;
    -webkit-flex: 7;
    flex: 7;
    padding-left:2vw;
}


.col2-row1{
  text-align:left;
  font-size:1em;
  color:#5A5D67;
}

.active .col2-row1{
  color:$color-orange;
}

.col2-row2{
  color:#999;
  font-size:0.65em;
  text-align:left;
  margin-top:2px;
  margin-bottom:2px;
}

.col2-row3{
  color:#999;
  font-size:0.7em;
  text-align:right;
  margin-top:2px;
  margin-bottom:2px;
  font-weight:200;
}

.col-3{
  font-size:2em;
  color:#ccc;
}

.note{
  padding:0 8px 0 22px;
  font-size:0.8em;
  color:#888;
  .german{
    margin-top:10px;
  }
}


.slogan{
  margin-top:6px;
  margin-bottom:5px;
  font-size:0.8em;
}

// .btn-box-fix .btn{
//   margin-top:0;
// }
</style>



// WEBPACK FOOTER //
// src/pages/pest/step2.vue